import { useCallback } from "react";
import useFeature from "hooks/useFeature";
import { NO_FIELD_NAME_SERIES, UNIT_FEATURE_FLAG } from "views/components/visualizations/Constants";
import useWidgetUnits from "views/components/visualizations/hooks/useWidgetUnits";
import getFieldNameFromTrace from "views/components/visualizations/utils/getFieldNameFromTrace";
import { getPieHoverTemplateSettings } from "views/components/visualizations/utils/chartLayoutGenerators";
const usePieChartDataSettingsWithCustomUnits = ({ config }) => {
  const unitFeatureEnabled = useFeature(UNIT_FEATURE_FLAG);
  const widgetUnits = useWidgetUnits(config);
  return useCallback(
    ({ name, fullPath, values }) => {
      var _a;
      if (!unitFeatureEnabled) return {};
      const fieldNameKey = (_a = getFieldNameFromTrace({ fullPath, series: config.series })) != null ? _a : NO_FIELD_NAME_SERIES;
      const unit = widgetUnits.getFieldUnit(fieldNameKey);
      return {
        fullPath,
        ...getPieHoverTemplateSettings({ convertedValues: values, unit, name })
      };
    },
    [config.series, unitFeatureEnabled, widgetUnits]
  );
};
export default usePieChartDataSettingsWithCustomUnits;
